import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivestreamsComponent } from './livestreams.component';
import {ExtendedModule, FlexModule} from '@angular/flex-layout';
import {MatTabsModule} from '@angular/material';



@NgModule({
  declarations: [LivestreamsComponent],
  exports: [
    LivestreamsComponent
  ],
  imports: [
    CommonModule,
    FlexModule,
    MatTabsModule,
    ExtendedModule
  ]
})
export class LivestreamsModule { }
